// Expanded coding words categorized by alphabet and programming languages
const codingWords = {
  a: {
    easy: ['add', 'api', 'app', 'arg', 'arr', 'ask', 'and', 'any', 'all', 'abs'],
    medium: ['array', 'async', 'await', 'auto', 'args', 'append', 'assert', 'axios', 'action'],
    hard: ['abstract', 'algorithm', 'attribute', 'animation', 'annotation', 'application', 'architecture']
  },
  b: {
    easy: ['bit', 'bug', 'bar', 'bin', 'bool', 'box', 'btn', 'byte', 'body'],
    medium: ['break', 'batch', 'buffer', 'branch', 'build', 'binary', 'button', 'base'],
    hard: ['boolean', 'background', 'benchmark', 'bytecode', 'bootstrap', 'backspace', 'blockchain']
  },
  c: {
    easy: ['case', 'call', 'code', 'css', 'cmd', 'char', 'col', 'core', 'copy'],
    medium: ['class', 'const', 'catch', 'clone', 'clear', 'count', 'cursor', 'cache'],
    hard: ['constructor', 'component', 'callback', 'collection', 'concurrency', 'container', 'controller']
  },
  d: {
    easy: ['def', 'doc', 'div', 'dom', 'del', 'dir', 'db', 'data', 'date'],
    medium: ['data', 'debug', 'delete', 'deploy', 'derive', 'default', 'define'],
    hard: ['database', 'decorator', 'dependency', 'destructor', 'dictionary', 'directive', 'development']
  },
  e: {
    easy: ['end', 'env', 'err', 'elm', 'exp', 'exit', 'eval', 'else', 'emit'],
    medium: ['error', 'event', 'else', 'enum', 'export', 'encode', 'entity'],
    hard: ['exception', 'extension', 'environment', 'encapsulation', 'execution', 'expression']
  },
  f: {
    easy: ['for', 'fun', 'fix', 'fmt', 'fn', 'file', 'flag', 'form', 'fork'],
    medium: ['func', 'from', 'false', 'fetch', 'float', 'field', 'frame', 'filter'],
    hard: ['function', 'framework', 'frontend', 'forbidden', 'fibonacci', 'functional', 'filesystem']
  },
  g: {
    easy: ['get', 'git', 'go', 'gui', 'gap', 'gen', 'gem', 'glob', 'grid'],
    medium: ['goto', 'group', 'graph', 'global', 'grant', 'guard', 'getter'],
    hard: ['generator', 'generic', 'gradient', 'grayscale', 'garbage', 'graphql', 'goroutine']
  },
  h: {
    easy: ['has', 'hex', 'hit', 'html', 'http', 'heap', 'head', 'host', 'hash'],
    medium: ['hash', 'hook', 'hover', 'height', 'handle', 'header', 'helper'],
    hard: ['handler', 'hierarchy', 'highlight', 'horizontal', 'hostname', 'hyperlink']
  },
  i: {
    easy: ['if', 'in', 'id', 'int', 'io', 'img', 'is', 'item', 'icon'],
    medium: ['item', 'icon', 'index', 'import', 'input', 'init', 'image', 'inline'],
    hard: ['interface', 'iterator', 'implement', 'inheritance', 'initialize', 'injection', 'instruction']
  },
  j: {
    easy: ['job', 'js', 'jar', 'jwt', 'json', 'jpg', 'joy', 'join', 'java'],
    medium: ['java', 'join', 'jump', 'jpeg', 'jest', 'junk', 'jquery'],
    hard: ['javascript', 'junction', 'jarfile', 'jsonify', 'jobqueue', 'jasmine']
  },
  k: {
    easy: ['key', 'kbd', 'kin', 'kit', 'kb', 'ks', 'kv', 'kill'],
    medium: ['kind', 'keep', 'kafka', 'kernel', 'keyword', 'keyup'],
    hard: ['keyframe', 'keystone', 'knowledge', 'kubernetes', 'keypress', 'keydown']
  },
  l: {
    easy: ['let', 'log', 'len', 'lib', 'list', 'link', 'loop', 'load', 'lock'],
    medium: ['load', 'local', 'lock', 'label', 'layer', 'layout', 'length'],
    hard: ['library', 'listener', 'lambda', 'lifecycle', 'localhost', 'location', 'lowercase']
  },
  m: {
    easy: ['map', 'max', 'min', 'mod', 'msg', 'mem', 'mix', 'menu', 'mode'],
    medium: ['main', 'method', 'model', 'module', 'mount', 'match', 'merge'],
    hard: ['middleware', 'migration', 'multithreading', 'metadata', 'microservice', 'markdown']
  },
  n: {
    easy: ['new', 'nil', 'node', 'not', 'npm', 'num', 'net', 'null', 'name'],
    medium: ['name', 'next', 'null', 'none', 'notify', 'native', 'number'],
    hard: ['namespace', 'navigation', 'normalize', 'notification', 'nullable', 'networking']
  },
  o: {
    easy: ['obj', 'opt', 'out', 'old', 'org', 'of', 'on', 'open', 'or'],
    medium: ['open', 'once', 'order', 'owner', 'object', 'option', 'output'],
    hard: ['operator', 'override', 'optimization', 'observable', 'overflow', 'operation']
  },
  p: {
    easy: ['pkg', 'ptr', 'put', 'pop', 'pub', 'py', 'php', 'port', 'path'],
    medium: ['push', 'path', 'parse', 'param', 'print', 'proxy', 'props'],
    hard: ['package', 'property', 'protocol', 'prototype', 'polymorphism', 'parameter', 'pipeline']
  },
  q: {
    easy: ['qt', 'qr', 'que', 'qty', 'qos', 'qa', 'quo', 'quit'],
    medium: ['query', 'queue', 'quick', 'quiet', 'quota', 'quote', 'quest'],
    hard: ['querystring', 'quaternion', 'qualified', 'quantifier', 'question']
  },
  r: {
    easy: ['run', 'ref', 'req', 'res', 'row', 'raw', 'rec', 'red', 'root'],
    medium: ['read', 'rest', 'route', 'range', 'redis', 'react', 'regex'],
    hard: ['render', 'response', 'request', 'repository', 'recursion', 'reducer', 'reference']
  },
  s: {
    easy: ['set', 'str', 'sql', 'sub', 'sum', 'svg', 'src', 'see', 'swap'],
    medium: ['sync', 'save', 'sort', 'start', 'state', 'stack', 'scope', 'style'],
    hard: ['string', 'switch', 'static', 'session', 'servlet', 'synchronize', 'structure', 'stringify']
  },
  t: {
    easy: ['try', 'tag', 'tmp', 'txt', 'tab', 'top', 'txt', 'type', 'test'],
    medium: ['test', 'type', 'then', 'this', 'true', 'throw', 'token', 'table'],
    hard: ['template', 'thread', 'transaction', 'transform', 'typescript', 'throttle', 'thumbnail']
  },
  u: {
    easy: ['url', 'ui', 'uid', 'use', 'usr', 'utc', 'uri', 'unix', 'uuid'],
    medium: ['user', 'unit', 'util', 'uuid', 'update', 'union', 'uint'],
    hard: ['undefined', 'unique', 'unsigned', 'unicode', 'unmount', 'upload', 'uppercase']
  },
  v: {
    easy: ['var', 'val', 'vue', 'vim', 'vcs', 'ver', 'via', 'view', 'void'],
    medium: ['void', 'view', 'value', 'valid', 'video', 'visit', 'vector'],
    hard: ['variable', 'virtual', 'validate', 'visibility', 'volatile', 'viewport', 'verification']
  },
  w: {
    easy: ['web', 'win', 'www', 'wrap', 'wip', 'ws', 'wav', 'wait', 'word'],
    medium: ['while', 'with', 'write', 'width', 'watch', 'wait', 'widget'],
    hard: ['window', 'wrapper', 'webhook', 'workspace', 'whitespace', 'wildcard', 'workflow']
  },
  x: {
    easy: ['xml', 'xhr', 'xor', 'x86', 'xls', 'xss', 'xyz', 'xsd'],
    medium: ['xpath', 'xcode', 'xhtml', 'xunit', 'xattr', 'xerror'],
    hard: ['expression', 'exception', 'execution', 'extension', 'extract']
  },
  y: {
    easy: ['y', 'yes', 'yml', 'yarn', 'yum', 'yank', 'yin', 'year'],
    medium: ['yield', 'year', 'yaml', 'yaxis', 'young', 'yank'],
    hard: ['youtube', 'yellowbox', 'yesterday', 'yottabyte']
  },
  z: {
    easy: ['zip', 'z', 'zen', 'zoo', 'zsh', 'zap', 'zig', 'zero', 'zone'],
    medium: ['zero', 'zone', 'zlib', 'zoom', 'zaxis', 'zend', 'zinx'],
    hard: ['zombie', 'zeppelin', 'zigzag', 'zerofill', 'zookeeper', 'zipfile']
  }
}

export function generateWords(alphabet, difficulty = 'easy', duration = 60) {
  const wordsForAlphabet = codingWords[alphabet] || codingWords['a']
  const wordList = wordsForAlphabet[difficulty] || wordsForAlphabet['easy']
  
  // Generate exactly 45-50 words to fit in 3 rows
  const targetWordCount = 45 + Math.floor(Math.random() * 6) // Random between 45-50
  
  const generatedWords = []
  
  for (let i = 0; i < targetWordCount; i++) {
    const randomWord = wordList[Math.floor(Math.random() * wordList.length)]
    generatedWords.push(randomWord)
  }
  
  return generatedWords.join(' ')
}

export function getAllAlphabets() {
  return Object.keys(codingWords)
}

export function getNextAlphabet(currentAlphabet) {
  const alphabets = getAllAlphabets()
  const currentIndex = alphabets.indexOf(currentAlphabet)
  if (currentIndex === -1 || currentIndex === alphabets.length - 1) {
    return 'a'
  }
  return alphabets[currentIndex + 1]
}
